import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-kt-payment-detail-modal',
  templateUrl: './kt-payment-detail-modal.component.html',
  standalone: false,
})
export class KtPaymentDetailModalComponent {
  constructor(
    public dialogRef: MatDialogRef<KtPaymentDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: number },
  ) {}

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
